export function zeroDecimal(decimals: number): string {
  return '0' + (decimals > 0 ? '.' + '0'.repeat(decimals) : '');
}

const THOUSANDS_SEPARATOR = '\u202f';

function groupThousands(integer: string): string {
  return integer.replace(/\B(?=(\d{3})+(?!\d))/g, THOUSANDS_SEPARATOR);
}

function formatNumberParts(sign: string, integer: string, fraction?: string): string {
  const groupedInteger = groupThousands(integer.replace(/^0+(?=\d)/, '') || '0');
  return sign + groupedInteger + (fraction === undefined ? '' : '.' + fraction);
}

export function truncateDecimalAmount(
  value: string | number | null | undefined,
  decimals = 2,
  fallback = '-'
): string {
  if (value === null || value === undefined) return fallback;
  const raw = String(value).trim();
  if (!raw) return fallback;

  const sign = raw.startsWith('-') ? '-' : '';
  const unsigned = raw.replace(/^[+-]/, '');

  if (!/^\d+(\.\d+)?$/.test(unsigned)) {
    const num = Number(raw);
    if (!Number.isFinite(num)) return fallback;
    const factor = 10 ** decimals;
    const truncated = Math.trunc(Math.abs(num) * factor) / factor;
    const [integer, fraction] = truncated.toFixed(decimals).split('.');
    return formatNumberParts(num < 0 ? '-' : '', integer, decimals === 0 ? undefined : fraction);
  }

  const [integerRaw, fractionRaw = ''] = unsigned.split('.');
  if (decimals === 0) return formatNumberParts(sign, integerRaw);
  const fraction = (fractionRaw + '0'.repeat(decimals)).slice(0, decimals);
  return formatNumberParts(sign, integerRaw, fraction);
}

export function formatSignedDecimal(value: number | string | null | undefined, suffix = ''): string {
  if (value === null || value === undefined || value === '') return 'N/A';
  const num = Number(value);
  if (!Number.isFinite(num)) return 'N/A';
  const sign = num > 0 ? '+' : num < 0 ? '-' : '';
  return sign + truncateDecimalAmount(Math.abs(num), 2) + suffix;
}

export function formatSignedUsd(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') return 'N/A';
  const num = Number(value);
  if (!Number.isFinite(num)) return 'N/A';
  const sign = num > 0 ? '+' : num < 0 ? '-' : '';
  return sign + '$' + truncateDecimalAmount(Math.abs(num), 2);
}

export function formatSignedPercent(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') return 'N/A';
  const num = Number(value);
  if (!Number.isFinite(num)) return 'N/A';
  const sign = num >= 0 ? '+' : '-';
  return sign + truncateDecimalAmount(Math.abs(num), 2) + '%';
}
